module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_01"
    }
  }, [_c('span', {
    staticClass: "partNumber"
  }, [_vm._v("Chapter 1"), _c('br'), _vm._v(" Elcho Falling")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "paraOpeningText"
  }, [_vm._v("E")]), _vm._v("lcho Falling lay quiet in the night. Its lord slept in the antechamber off the main command chamber, his lady wife by his side. An hour or so ago he had been dead, murdered through the treachery of a woman he’d once taken to his bed, but now he lay whole and clean and breathing again due to the power and love of his wife, Ishbel.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They lay sleeping, Elcho Falling quiet about them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All was still, save for the deeper treachery that was about to be enacted against them.")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("Go! "), _c('i', [_vm._v("whispered the One, and in Elcho Falling Eleanon and his twelve thousand fighters picked up their weapons and dissolved into invisibility.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("A moment later and they were dispersing throughout the citadel, seeking out the units of the Strike Force, an unseen cloud of silent death.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Go! "), _c('i', [_vm._v("whispered the One, and in the Twisted Tower Josia frowned at the scratching at the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("He opened it, and stared bemused at the red tabby cat that entered and wound its way about his ankles.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And now I! "), _c('i', [_vm._v("whispered the One, and he stepped through Eleanon’s Dark Spire, which the Leafast man had placed in the very depths of Elcho Falling, flexed his shoulders, and began the long climb up into the heart of the citadel. As he rose, he began to sing, a triumphal chorus drawn from the depths of darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("Infinity had come to claim Elcho Falling, and death its inhabitants.")])]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("Maximilian Persimius rolled out of the bed, hitting the floorboards with a thump.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For a moment he lay half crouched on the floor, his eyes keen, his head tipped very slightly to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he rose in one fluid movement and grabbed the blood-stained breeches that had been tossed to one side of the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The One is here,” he said, almost conversationally.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ishbel rose from the bed, winding a sheet about her body. “Where?” she said, her voice and demeanour as calm as Maximilian’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Far below,” said Maximilian, sliding his feet into his boots. “We have a little while. Some minutes, perhaps.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How?” said Ishbel, and for the first time Maximilian displayed some emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We have been betrayed once more,” he said, and strode for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("Axis and Inardle were on the stairs, walking down to the level which held their suite of chambers. They were still quiet, stunned into introspection by what Garth Baxtor had told them as he’d come from the antechamber which both Axis and Inardle had thought held only Maximilian’s dead body.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Ishbel healed him,” Garth had said. “Now they sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They rounded a corner and Axis stopped suddenly. He lifted his head, peering upward.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What is it?” Inardle said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Axis held up a hand for silence, then spoke after a moment’s hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I can hear the clash of swords,” he said. “There is fighting somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His entire body tensed as he spoke, and now he peered about, listening intensely, not noticing that Inardle had gone utterly white.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Treachery,” whispered Axis, then he began to climb the stairs three at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Inardle stared after him, then followed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t know what to do, or what to say. She knew what had happened — her brother Eleanon would have launched an attack against the Strike Force — but what could she say to Axis?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As she trailed behind Axis, sick to her stomach, she used a discreet amount of her power to heal her wings.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then she started to look for an open window.")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("Two turns of the stairs and Axis literally ran into Maximilian who was on his way down.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Axis grasped Maximilian by the shoulders. “Thank the stars you live,” he muttered. “Maxel, there is treachery. I —”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Indeed,” Maximilian said. “There is fighting above us. And, worse, the One is in Elcho Falling’s basement, rising up this very stairwell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before Axis had a chance to respond, one of the Strike Force members, StarHeaven, spoke into his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("StarMan, we are under attack. From the Leafast, we think. They are invisible, appearing only if we can wound one through sheer luck. StarMan, we are desperate. BroadWing is dead. We are all dying. . . ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dear Gods,” Axis whispered. "), _c('i', [_vm._v("Help is on its way,")]), _vm._v(" he sent back to StarHeaven, although he had no idea "), _c('i', [_vm._v("what")]), _vm._v(" help could be of aid to them. “The Lealfast are attacking the Strike Force,” he said to Maximilian. “They are invisible, and are murdering my fellows.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he spun about and seized Inardle by the wrist. “"), _c('i', [_vm._v("What do you know of this?”")]), _vm._v(" he hissed at her. He saw that her wings were healed and hatred filled him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("She had betrayed both him and Elcho Falling.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Inardle shrank back as far as she could. “I’m sorry, Axis. I couldn’t tell you. I —”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Axis’ hand jerked even tighter about Inardle’s wrist, and she cried out in pain, half sinking to her knees. He opened his mouth to speak, to hiss at Inardle, to hurl abuse at her, but was forestalled by Ishbel’s calm voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I can help with the invisibleness,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Axis whipped about.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ishbel stood a few steps above Maximilian, garbed only in a sheet wound about her body.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In her hands she held the Goblet of the Frogs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“This remains filled with Maximilian’s blood,” Ishbel said, her voice unnaturally calm given the circumstances. “It remains filled with the power of the murdered Lord of Elcho Falling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She lifted one hand, dipped its fingers into the goblet, then flicked them out in a circle as she turned on her heel.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Blood droplets filled the space of the stairwell, hanging suspended in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Who plots treachery,” Ishbel said, her voice thick with power, “must now be stained.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then, all of a sudden, the droplets of blood flew outward, and abruptly disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The next moment, StarHeaven spoke again in Axis’ mind. "), _c('i', [_vm._v("My thanks to you, StarMan. The Lealfast are now visible, stained with blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("Not my doing,")]), _vm._v(" said Axis, "), _c('i', [_vm._v("but that of the Lady of Elcho Falling. Standfast, I shall be with you shortly.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I need a guard for Inardle,” said Axis. “She has betrayed us, as have her fellows.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Inardle cringed at the flat coldness of Axis’ voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I shall take responsibility for her,” said Ishbel. “All fighters are needed elsewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” said Axis. “She needs swords and —”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I shall take responsibility for her,” Ishbel said again. “Go now, Axis, you are needed elsewhere desperately.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Still Axis held on to Inardle’s wrist. “What about the One?” he said to Maximilian.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The One is my battle alone,” said Maximilian. “Axis, do as Ishbel says.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Be careful of her,” Axis said to Ishbel. He tipped his head at Inardle. “She deceived me too easily, the treacherous bitch. Trust not one word she utters.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he was gone, running upward past Ishbel and Maximilian, and vanishing down a side corridor. Inardle crouched on the stairs, her eyes wary as they followed Axis, then she looked at Ishbel, one hand rubbing at her bruised wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ishbel lifted the hand she’d used to scatter the blood and laid it against Maximilian’s cheek. “What can I do to aid you?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nothing,” he said. “This must be my battle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ishbel nodded, accepting it. “Then be careful, and come back to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Maximilian kissed her cheek, and was gone down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Now there’s just you and me,” Ishbel said to Inardle. “What "), _c('i', [_vm._v("shall")]), _vm._v(" I do with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("Axis had taken two turns down the corridor, racing for the Strike Force’s quarters, when StarDrifter appeared from a doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I have an idea,” he said to Axis, taking his son’s arm as he spoke low and rapid.")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("The One rose slowly through the stairwell that wound upward from the very pit of Elcho Falling. He was climbing with more caution than he had initially, and had stopped singing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Lord of Elcho Falling knew he was here. The element of surprise had vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I rise to greet you,” the One whispered, his obsidian eyes gleaming.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then he jumped in surprise as thick, dark blood spattered over his face, neck and chest.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b975c9b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 81
// module chunks = 0